import { IconButton, HStack } from '@lib/uikit';
import { FC } from 'react';

import { useVideoPlayerContext } from '../../contexts/VideoPlayerContext';

export const VideoPlayerButtons: FC = () => {
    const { buttons } = useVideoPlayerContext();

    return (
        <HStack spacing='xxxs' justifyContent='space-between'>
            {buttons.map((iconButtonProps, index) => (
                <IconButton
                    key={`video-player-button-${index}`}
                    buttonSize='large'
                    {...iconButtonProps}
                />
            ))}
        </HStack>
    );
};
